// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import ScrollToTop from "./components/ScrollToTop";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import DemoLogin from "./pages/DemoLogin";
import DemoConsole from "./pages/DemoConsole";

function MarketingLayout({ children }) {
  return (
    <>
      <Navbar />
      <div className="navbar-space" />
      {children}
      <Footer />
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  const isDemo = location.pathname.startsWith("/demo");

  if (isDemo) {
    return (
      <Routes>
        <Route path="/demo/login" element={<DemoLogin />} />
        <Route path="/demo" element={<DemoConsole />} />
      </Routes>
    );
  }

  return (
    <MarketingLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </MarketingLayout>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
      <Analytics />
    </Router>
  );
}

export default App;
